// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"4f36fc50","221":"80e4c703","289":"f8b12a03","354":"9779706b","361":"22c2a05a","785":"2c381124","936":"99dc284c"}[chunkId] + ".chunk.js";
};